module.exports = __webpack_public_path__ + "img/ClickForSound_18.89dc60a5.png";